import { Injector } from '@angular/core';
import { ConfigService } from '@core/shared/config';
import { FeaturePlugin, FeatureRegistry } from '@core/shared/feature';
import { FrontendFeatureFunctionalityBuilder } from './frontend-feature-functionality-builder';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/feature";
import * as i2 from "@core/shared/config";
export let FrontendFeaturePlugin = /*#__PURE__*/(() => {
  class FrontendFeaturePlugin extends FeaturePlugin {
    constructor(registry, config, injector) {
      super();
      this.config = config;
      this.injector = injector;
      registry.add(this);
    }
    getFunctionalityBuilder() {
      return new FrontendFeatureFunctionalityBuilder();
    }
    static {
      this.ɵfac = function FrontendFeaturePlugin_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FrontendFeaturePlugin)(i0.ɵɵinject(i1.FeatureRegistry), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: FrontendFeaturePlugin,
        factory: FrontendFeaturePlugin.ɵfac
      });
    }
  }
  return FrontendFeaturePlugin;
})();